// @ts-strict-ignore
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSnackBar } from '@usealloy/component-library';
import log from '~/helpers/logging';
import { ajaxFetch } from '~/helpers/api';
import { routes } from '~/helpers/routes';
import type { Notification } from '~/dashboard/context';
import { formatTimestamp } from '~/helpers/formatting';

type NotificationData = {
  content: string;
  notification_id: number;
  notification_type?: string;
  timestamp: string;
  title: string;
  url?: string;
  viewed: boolean;
};

export function useFetchNotifications({ isAuthenticated }: { isAuthenticated: boolean }) {
  const [error, setError] = useState(false);
  const addSnackBar = useSnackBar();

  const { data } = useQuery({
    enabled: isAuthenticated,
    onError: err => {
      setError(true);
      log('error', 'Error fetching notifications', {}, err);
      addSnackBar({
        duration: 5_000,
        title: 'Something went wrong fetching notifications. Please refresh the page or contact support.',
        type: 'danger',
      });
    },
    queryFn: async (): Promise<Notification[]> => {
      const result: {
        notifications: NotificationData[];
      } = await ajaxFetch(routes.v3.notifications);

      return (result?.notifications || []).map(notification => ({
        formattedTimestamp: formatTimestamp(notification.timestamp),
        notificationId: notification.notification_id,
        notificationType: notification.notification_type,
        viewed: notification.viewed,
        title: notification.title,
        timestamp: notification.timestamp,
        content: notification.content,
        url: notification.url,
      }));
    },
    queryKey: ['ruleBasedNotifications'],
    refetchInterval: () => (error ? false : 60000),
    retry: false,
  });

  return { notifications: data || [] };
}
